import { selectProjectsTableView, useAppSelector } from '@core/core/store'
import { usePagination } from '@core/core/utils'
import { useMemo } from 'react'

import type { ProjectDetailExtended } from './types'
import { useFavorite } from './useFavorite'

const PROJECT_PER_PAGE = 20

export const useProjects = (query: string) => {
  const allProjectsRaw = useAppSelector(state => selectProjectsTableView(state, query))
  const { toggleFavorite, isFavorite } = useFavorite()

  const projects = useMemo(
    () =>
      allProjectsRaw
        .map<ProjectDetailExtended>(project => ({ ...project, isFavorite: isFavorite(project.id) }))
        .sort(project => (project.isFavorite ? -1 : 0)),
    [allProjectsRaw, isFavorite],
  )
  const pagination = usePagination(projects, PROJECT_PER_PAGE)

  return {
    ...pagination,
    toggleFavorite,
    hasPagination: allProjectsRaw.length > PROJECT_PER_PAGE,
  }
}
